import { ENGLISH_COURSE_ID } from '../constants.ts'

const ENGLISH_COURSE_LEVELS = new Set(['A1', 'A2', 'B1', 'B2'])

export function getVisibleProgramLevels<T extends string>(
  levels: readonly T[],
  courseId: number | null | undefined,
): T[] {
  if (courseId !== ENGLISH_COURSE_ID) return [...levels]
  return levels.filter((level) => ENGLISH_COURSE_LEVELS.has(level))
}

export function isNavigationItemVisible(
  text: string,
  courseId: number | null | undefined,
  uiLocale: string,
): boolean {
  const isEnglishCourse = courseId === ENGLISH_COURSE_ID
  return !(
    (text === 'navbar.speaking' && isEnglishCourse) ||
    (text === 'navbar.testMode' && (uiLocale === 'ru' || isEnglishCourse))
  )
}
